<template>
    <div
        class="availability"
        v-if="module">
        <design-2021-module-index-availability-form-component
            @change="moduleDatesUpdate"
            :module-dates-in="moduleDates"
            :module-periods-in="modulePeriodsIn">
        </design-2021-module-index-availability-form-component>

        <b-button
            variant="primary"
            @click="onOk">
            {{ $t('common.save') }}
        </b-button>
    </div>
</template>

<script>
import { ords } from '../../../app';

const moduleOrds = ords.use('module');

export default {
    name: 'design-2021-module-managment-edit-date-component',
    props: ['moduleIn', 'modulePeriodsIn'],
    data() {
        return {
            moduleDates: null,
            module: null,
        };
    },
    methods: {
        moduleDatesUpdate(dates) {
            const idSet = new Set(dates.map((obj) => obj.id));
            this.moduleDates = this.moduleDates.filter((mDate) => idSet.has(mDate.id));

            // geen idee wat dit zou moeten doen.
            this.moduleDates = this.moduleDates.filter((moduleDate) => 'id' in moduleDate);

            this.moduleDates = this.moduleDates.map((moduleDate) => {
                let localDate = { ...moduleDate };

                for (const updatedDate of dates) {
                    if (moduleDate.id === updatedDate.id) {
                        localDate.module_period = updatedDate.modulePeriod;
                        localDate.module_period_id = updatedDate.modulePeriod.id;
                        localDate.max = updatedDate.max;
                    }
                }

                return localDate;
            });

            for (const updatedDate of dates) {
                if (!('id' in updatedDate)) {
                    this.moduleDates.push({
                        max: updatedDate.max,
                        module_id: this.moduleIn.id,
                        module_period: updatedDate.modulePeriod,
                        module_period_id: updatedDate.modulePeriod.id,
                    });
                }
            }
        },

        onOk() {
            let data = {
                item: this.moduleDates.map((md) => {
                    md.modulePeriodId = md.module_period.id;
                    return md;
                }),
            };

            this.alert.saving();

            this.axios.post(this.routes.updateModuleDates(this.module.id), data).then(
                (response) => {
                    ords.hold();

                    dateLoop: for (const date of this.module.module_dates) {
                        for (const responseDate of response.data.module_dates) {
                            if (responseDate.id === date.id) {
                                date.update(date, response.data.id);
                                continue dateLoop;
                            } else if (!date.id) {
                                continue dateLoop;
                            }
                        }
                        this.module.detach('module_dates', date.id);
                    }

                    responseDateLoop: for (const responseDate of response.data.module_dates) {
                        for (const date of this.module.module_dates) {
                            if (responseDate.id === date.id) {
                                continue responseDateLoop;
                            }
                        }
                        this.module.addRelation('module_dates', responseDate);
                    }

                    this.module.update(response.data, response.data.id);

                    ords.continue();

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
    mounted() {
        moduleOrds.add(this.moduleIn);

        moduleOrds
            .with('module_dates', function (q) {
                q.with('module_users'); // todo pull out user model from here relation not set yet
                q.with('module_period', (modulePeriodsCallback) => {
                    modulePeriodsCallback.with('period');
                });
            })
            .find(this.moduleIn.id)
            .subscribe((module) => {
                this.module = module;
            });

        this.moduleDates = this.module.module_dates
            ? this.module.module_dates.reverse().map((moduleDate) => moduleDate)
            : [];
    },
};
</script>

<style scoped></style>
